import { inject, Injector } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flag.service';

/**
 * Route guard that checks whether a feature flag is enabled for the current club.
 * Pass the feature flag key via route data: { featureFlag: 'expense-tracking' }
 *
 * A feature is considered enabled if isEnabledForClub OR isEnabledGlobally is true,
 * matching the same logic used by the sidebar.
 */
export const FeatureFlagGuard: CanActivateFn = async (route) => {
  const injector = inject(Injector);
  const featureFlagService = injector.get(FeatureFlagService);
  const router = injector.get(Router);

  const featureKey = route.data?.['featureFlag'] as string | undefined;
  if (!featureKey) {
    return true;
  }

  const isMobile = route.queryParams?.['mobile'] === 'true';
  const dashboardExtras = isMobile ? { queryParams: { mobile: 'true' } } : {};

  const clubId = localStorage.getItem('currentClubId');
  if (!clubId) {
    router.navigate(['/dashboard'], dashboardExtras);
    return false;
  }

  try {
    const flags = await featureFlagService.getClubFeatureFlags(clubId);
    if (flags) {
      const flag = flags.find(f => f.key === featureKey);
      if (flag?.isEnabledForClub || flag?.isEnabledGlobally) {
        return true;
      }
    }
  } catch (error) {
    console.error('FeatureFlagGuard: Error checking feature flag:', error);
  }

  router.navigate(['/dashboard'], dashboardExtras);
  return false;
};
